import React from "react";

const SvgComponent = props => (
  <svg width={43.242} height={39.225} viewBox="0 0 43.242 39.225" {...props}>
    <g fill="#83a5b3">
      <path d="M19.432 31.597c-.281.44-5.02 7.627-5.02 7.627l8.922-7.753c.535-.469.496-.596.121-1.286a312.06 312.06 0 00-1.383-2.562c-.258-.458-.295-.447-.031-.873.26-.427 5.492-9.202 5.492-9.202s-8.41 7.223-9.102 7.82c-.988.854-.973 1.016-.461 2.131.262.568 1.316 2.833 1.516 3.211.213.401.27.383-.054.887z" />
      <path d="M32.375 13.823c1.451-.588 2.902-.541 3.318-.541 2.082 0 4.596 1.82 4.596 4.81a4.598 4.598 0 01-4.596 4.599h-7.234c-.777 0-1.406.631-1.406 1.409 0 .774.629 1.403 1.406 1.403h7.229a7.555 7.555 0 007.556-7.555s.036-7.546-7.902-7.546c-1.717-7.069-8.334-7.428-10.188-6.929C23.139 1.47 19.789 0 16.404 0 9.686 0 4.184 5.192 3.688 11.783a7.348 7.348 0 003.66 13.72h6.99c.639 0 1.236-.688 1.236-1.406 0-.777-.631-1.406-1.406-1.406H7.982c-2.742 0-4.768-1.987-4.768-4.558 0-2.099 1.332-3.939 3.416-4.567.248-9.922 8.963-10.43 9.932-10.43 2.879 0 5.734 1.413 7.572 3.504 3.716-1.222 8.811 1.643 8.241 7.183z" />
    </g>
  </svg>
);

export default __webpack_public_path__ + "static/media/11d.bc6f153e.svg";
export { SvgComponent as ReactComponent };



// WEBPACK FOOTER //
// ./src/assets/weather-icons/11d.svg